<template>
  <a-card :bordered="false" class="header-solid h-full">
    <!-- 
            Title 
        -->
    <template #title>
      <!-- 
                Desktop's view 
            -->
      <a-row v-if="!isMobile()" type="flex" justify="space-between" align="top">
        <a-col :span="8">
          <h5 class="font-semibold m-0">Access log</h5>
        </a-col>
        <a-col :span="12">
          <div style="float: right; padding-right: 5px">
            <a-date-picker @change="onDateChanged" />
          </div>
          <div style="float: right">
            <div style="float: right; margin-left: 5px">
              <a-button
                type="default"
                shape="circle"
                icon="arrow-right"
                @click="onNextDate"
              />
            </div>
            <div style="float: right; margin-left: 5px">
              <a-button
                type="default"
                shape="circle"
                icon="arrow-left"
                @click="onPreviousDate"
              />
            </div>
            <div style="float: right; margin-left: 5px">
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>Download excel file</span>
                </template>
                <a-button
                  type="default"
                  shape="circle"
                  icon="file-excel"
                  @click="onClickDownloadExcel"
                />
              </a-tooltip>
            </div>
          </div>
        </a-col>
      </a-row>

      <!-- 
                Mobile's view 
            -->
      <a-row v-else type="flex" justify="space-between" align="top">
        <a-col :span="12">
          <h5 class="font-semibold m-0">Access log</h5>
        </a-col>
        <a-col :span="12">
          <div style="float: right; margin-left: 5px">
            <a-popover v-model="visible" trigger="click">
              <a slot="content" @click="hide">
                <a-date-picker @change="onDateChanged" />
              </a>
              <a-button type="default" shape="circle" icon="search" />
            </a-popover>
          </div>
          <div style="">
            <div style="float: right; margin-left: 5px">
              <a-button
                type="default"
                shape="circle"
                icon="arrow-right"
                @click="onNextDate"
              />
            </div>
            <div style="float: right; margin-left: 5px">
              <a-button
                type="default"
                shape="circle"
                icon="arrow-left"
                @click="onPreviousDate"
              />
            </div>
            <div style="float: right">
              <a-button
                type="default"
                shape="circle"
                icon="file-excel"
                @click="onClickDownloadExcel"
              />
            </div>
          </div>
        </a-col>
      </a-row>
    </template>

    <!-- 
            Body, mobile's view
        -->
    <a-table
      v-if="isMobile()"
      :columns="columnsForMobile"
      :data-source="data"
      rowKey="_id"
    >
      <template slot="date" slot-scope="date, record">
        <a-icon type="calendar" /> {{ date.replace("T", " ").substring(0, 19)
        }}<br />
        <a-icon type="mail" /> {{ record.email }}<br />
        <a-icon type="idcard" /> {{ record.card }}<br />
        <a-icon type="bank" /> {{ record.room }}<br />
      </template>
      <template slot="status" slot-scope="status">
        <a-tag v-if="status === 'allow'" color="green">{{
          status.charAt(0).toUpperCase() + status.slice(1)
        }}</a-tag>
        <a-tag v-else color="red">{{
          status.charAt(0).toUpperCase() + status.slice(1)
        }}</a-tag>
      </template>
    </a-table>

    <!-- 
            Body, destop's view
        -->
    <a-table v-else :columns="columns" :data-source="data" rowKey="_id">
      <template slot="date" slot-scope="date">
        {{ date.replace("T", " ").substring(0, 19) }}
      </template>
      <template slot="status" slot-scope="status">
        <a-tag v-if="status === 'allow'" color="green">{{
          status.charAt(0).toUpperCase() + status.slice(1)
        }}</a-tag>
        <a-tag v-else color="red">{{
          status.charAt(0).toUpperCase() + status.slice(1)
        }}</a-tag>
      </template>
    </a-table>
  </a-card>
</template>

<script>
import axios from "axios";
import moment from "moment";
import tools from "../../utils/tools";

export default {
  props: {
    // roomId: String,
  },
  components: {},
  data() {
    return {
      visible: false,
      date: new Date().toISOString().split("T")[0],
      query: "",
      data: [],
      columns: [
        {
          title: "Date",
          dataIndex: "date",
          scopedSlots: { customRender: "date" }
        },
        {
          title: "Email",
          dataIndex: "email",
          scopedSlots: { customRender: "email" }
        },
        {
          title: "Card",
          dataIndex: "card",
          scopedSlots: { customRender: "card" }
        },
        {
          title: "Room",
          dataIndex: "room",
          scopedSlots: { customRender: "room" }
        },
        {
          title: "Status",
          dataIndex: "status",
          scopedSlots: { customRender: "status" }
        }
      ],
      columnsForMobile: [
        {
          title: "Date",
          dataIndex: "date",
          scopedSlots: { customRender: "date" }
        },
        {
          title: "Status",
          dataIndex: "status",
          scopedSlots: { customRender: "status" }
        }
      ]
    };
  },
  //
  //
  //
  mounted() {},
  methods: {
    //
    //
    //
    hide() {
      this.visible = false;
    },
    //
    //
    //
    isMobile() {
      return tools.isMobile();
    },
    //
    //
    //
    setQuery(query) {
      this.query = query;
    },
    //
    //
    //
    onDateChanged(date, dateString) {
      this.date = dateString;
      this.requestData();
    },
    //
    //
    //
    onNextDate() {
      this.date = moment(this.date).add(1, "days").format("YYYY-MM-DD");
      this.requestData();
    },
    //
    //
    //
    onPreviousDate() {
      this.date = moment(this.date).add(-1, "days").format("YYYY-MM-DD");
      this.requestData();
    },
    //
    //
    //
    requestData() {
      if (this.date.length === 0) {
        this.data = [];
        return;
      }

      axios
        .get(
          process.env.VUE_APP_INVENTORY_API +
            "/accesslog/search?date=" +
            this.date +
            "&" +
            this.query,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          }
        )
        .then(response => {
          this.data = response.data.data;
        })
        .catch(error => {
          this.$notification.open({
            message: "Notification",
            description: error.response.data.message,
            icon: <a-icon type="close-circle" style="color: #FF0000" />
          });
          return;
        });
    },
    //
    //
    //
    onClickDownloadExcel() {
      let csv = "Date,Email,Card,Room,Status\n";
      this.data.forEach(row => {
        csv += row.date + ",";
        csv += row.email + ",";
        csv += row.card + ",";
        csv += row.room + ",";
        csv += row.status + ",";
        csv += "\n";
      });

      const anchor = document.createElement("a");
      anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = "access-log.csv";
      anchor.click();
    }
  }
};
</script>

<style lang="scss">
.ant-calendar-picker {
  width: 100%;
}
</style>
